export interface ModelPeriodTypesPayload {
  id?: number;
  modelDetailedResult?: number;
  periodTypes?: number;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function extractModelDetailedResultId(input: any): number | undefined {
  const direct = toNumber(input?.modelDetailedResult);
  if (direct !== undefined) {
    return direct;
  }
  return toNumber(input?.modelDetailedResult?.id);
}

function extractPeriodTypeId(input: any): number | undefined {
  const direct = toNumber(input?.periodTypes);
  if (direct !== undefined) {
    return direct;
  }
  return toNumber(input?.periodTypes?.id);
}

export function buildModelPeriodTypesPayload(input: any): ModelPeriodTypesPayload {
  const payload: ModelPeriodTypesPayload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const modelDetailedResult = extractModelDetailedResultId(input);
  if (modelDetailedResult !== undefined) payload.modelDetailedResult = modelDetailedResult;

  const periodTypes = extractPeriodTypeId(input);
  if (periodTypes !== undefined) payload.periodTypes = periodTypes;

  return payload;
}
